import React, {FC, useState} from 'react'
import {useEffectOnce} from 'react-use'
import {inject, observer} from 'mobx-react'
import {RouteComponentProps} from 'react-router-dom'
import classnames from 'classnames'
import OderTop from '@/components/Order/Top'
import OrderTable from '@/components/Order/OrderTable'
import {listItemType, orderType, statusType, User, priceType} from '@/types/OrderType'
import {UserStoreProps} from '@/stores/user'
import Modali from '@/components/Modal'
import {ColumnProps} from "antd/lib/table";
import DateTime from "@/utils/DateTime";
import yuan from "@/utils/yuan";
import {message, Modal} from "antd";
import report from '@/utils/log'


export type OrderProps = UserStoreProps & RouteComponentProps

const Order: FC<OrderProps> = inject('UserStore')(observer(props => {
  let {OrderStore} = props.UserStore
  let {selected, deviceOrder, addOrder, orderDetail, getOrderDetail} = OrderStore
  let dataSource = selected === 0 ? deviceOrder : addOrder
  const [showModal, setMoadl] = useState(false)


  useEffectOnce(() => {
    // 订单详情加载成功 事件上报
    selected === 0 && report({
      eventId: 'E1600',
      pageId: 'P16',
      ext: '',
    })
    selected === 1 && report({
      eventId: 'E1800',
      pageId: 'P18',
      ext: '',
    })
    OrderStore.init()
  })

  const lookDetail = (obj: listItemType) => {
    // 点击查看详情 事件上报
    selected === 0 && report({
      eventId: 'E1603',
      pageId: 'P16',
      ext: '',
    })

    selected === 1 && report({
      eventId: 'E1803',
      pageId: 'P18',
      ext: '',
    })

    if (selected === 0 && obj.status === 0) {
      message.error('暂无详细信息')
      return;
    }
    setMoadl(true)
    getOrderDetail(obj.order_id)
  }
  // 设备订单
  const columns = (): ColumnProps<User & listItemType>[] => {
    const columnsDevice: ColumnProps<User & listItemType>[] = [
      {
        title: '购买时间',
        dataIndex: 'order_time',
        ellipsis: true,
        width: '157px',
        render: (text) => {
          return DateTime.timestampToTime(text) || '-'
        }
      }, {
        title: '商品名称',
        dataIndex: 'product_name',
        width: '126px',
        ellipsis: true,
      }, {
        title: '订单类型',
        dataIndex: 'order_type',
        width: '126px',
        ellipsis: true,
        render: (text, record) => {
          return text === 1 ? priceType[record.price_type] : orderType[0]
        }
      }, {
        title: '订单号',
        dataIndex: 'order_id',
        width: '213px',
        ellipsis: true,
      }, {
        title: '购买单价 (元)',
        dataIndex: 'single_price',
        width: '130px',
        ellipsis: true,
        align: 'right',
        render: (text) => {
          return yuan(text).toFixed(2)
        }
      }, {
        title: '购买个数',
        dataIndex: 'total_num',
        width: '100px',
        ellipsis: true,
        align: 'center'
      }, {
        title: '实付金额 (元)',
        dataIndex: 'total_price',
        width: '130px',
        ellipsis: true,
        align: 'right',
        render: (text) => {
          return yuan(text).toFixed(2)
        }
      }, {
        title: '交易结果',
        dataIndex: 'status',
        width: '130px',
        ellipsis: true,
        align: 'center',
        render: (text) => {
          return <span className={classnames({paying: text !== 1})}>{statusType[text]}</span>
        }
      }, {
        title: '操作',
        align: 'center',
        render: (text, record: listItemType) => {
          return <span className={classnames('lookDetail')} onClick={() => lookDetail(record)}>查看详情</span>
        }
      }
    ];
    const columnsAdd: ColumnProps<User & listItemType>[] = [
      {
        title: '购买时间',
        dataIndex: 'order_time',
        width: '157px',
        render: (text) => {
          return DateTime.timestampToTime(text) || '-'
        }
      }, {
        title: '商品名称',
        dataIndex: 'title',
        width: '126px'
      }, {
        title: '订单类型',
        dataIndex: 'order_type',
        width: '126px',
        render: (text) => {
          return priceType[1]
        }
      }, {
        title: '订单号',
        dataIndex: 'order_id',
        width: '213px'
      }, {
        title: '购买单价 (元)',
        dataIndex: 'single_price',
        width: '130px',
        align: 'right',
        render: (text) => {
          return yuan(text).toFixed(2)
        }
      }, {
        title: '购买个数',
        dataIndex: 'total_num',
        width: '100px',
        align: 'center'
      }, {
        title: '实付金额 (元)',
        dataIndex: 'total_price',
        width: '130px',
        align: 'right',
        render: (text) => {
          return yuan(text).toFixed(2)
        }
      }, {
        title: '交易结果',
        dataIndex: 'status',
        width: '130px',
        align: 'center',
        render: (text) => {
          return <span className={classnames({paying: text !== 1})}>{statusType[text]}</span>
        }
      }, {
        title: '操作',
        align: 'center',
        render: (text, record: listItemType) => {
          return <span className={classnames('lookDetail')} onClick={() => lookDetail(record)}>查看详情</span>
        }
      }
    ];
    if (selected === 0) return columnsDevice;
    if (selected === 1) return columnsAdd
    return []
  }

  const cancelModal = function () {
    // 详情弹窗关闭 事件上报
    selected === 0 && report({
      eventId: 'E1701',
      pageId: 'p17',
      ext: '',
    })
    selected === 1 && report({
      eventId: 'E1902',
      pageId: 'p19',
      ext: '',
    })
    setMoadl(false)
  }

  return (
    <div className={classnames('gc_order')}>
      {/*导航*/}
      <OderTop selected={selected} changeSelect={OrderStore.changeSelect}></OderTop>
      {/*表格*/}
      <OrderTable dataSource={dataSource} columns={columns()}></OrderTable>
      {/*详情*/}
      <Modal
        title='购买详情'
        visible={showModal}
        className='gc_order_detail_wrapper'
        onCancel={cancelModal}
        footer={null}
      >
        <Modali.OrderDetail orderDetail={orderDetail}></Modali.OrderDetail>
      </Modal>
    </div>
  )
}))

export default Order
